import { get, type RequestOptions } from '@/api/client';
import { adaptCalendarDayResponse, adaptCalendarMonthResponse, adaptCalendarNext7Response } from '../adapters/calendarAdapters';
import type { CalendarQueryParams } from './calendarFilterParams';
import type {
  AppointmentPeek,
  CalendarDayResponseRaw,
  CalendarMonthResponseRaw,
  CalendarNext7ResponseRaw,
} from './types';

export const calendarApi = {
  getDay: async (
    locationId: number,
    date: string,
    filters: CalendarQueryParams = {},
    options?: RequestOptions,
  ) => {
    const raw = await get<CalendarDayResponseRaw>(
      '/api/calendar/day',
      {
        location: locationId,
        date,
        ...filters,
      },
      options,
    );
    return adaptCalendarDayResponse(raw);
  },

  getNext7: async (
    locationId: number,
    start: string,
    filters: CalendarQueryParams = {},
    options?: RequestOptions,
  ) => {
    const raw = await get<CalendarNext7ResponseRaw>(
      '/api/calendar/next7',
      {
        location: locationId,
        start,
        ...filters,
      },
      options,
    );
    return adaptCalendarNext7Response(raw);
  },

  getMonth: async (
    locationId: number,
    year: number,
    month: number,
    filters: CalendarQueryParams = {},
    options?: RequestOptions,
  ) => {
    const raw = await get<CalendarMonthResponseRaw>(
      '/api/calendar/month',
      {
        location: locationId,
        year,
        month,
        ...filters,
      },
      options,
    );
    return adaptCalendarMonthResponse(raw);
  },

  getAppointmentPeek: (appointmentId: number, options?: RequestOptions) =>
    get<AppointmentPeek>(`/api/appointments/${appointmentId}/peek`, undefined, options),
};
